export const CompPlexCommercialLeaseEvents = {
  EDIT_COMP_UPDATED: 'compplex-crc-edit-comp-updated',
  EDIT_COMP_CLOSED: 'compplex-crc-edit-comp-closed',
  FOUND_COMP_ADDED: 'compplex-crc-found-comp-added',
  MAP_COMP_ADDED: 'compplex-crc-map-comp-added',
  MAP_COMP_REMOVED: 'compplex-crc-map-comp-removed',
  MAP_EDIT_MODAL_OPENED: 'compplex-crc-map-edit-modal-opened',
  MAP_EDIT_MODAL_CLOSED: 'compplex-crc-map-edit-modal-closed',
  ERROR: 'compplex-error',
};

export const RentTypesUnitsOfMeasure = {
  ANNUAL: 'annually',
  PER_SF_PER_YEAR: 'per square foot per year',
  PER_SF_PER_MONTH: 'per square foot per month',
  MONTHLY: 'monthly',
};
